import React from 'react'
import {useCentralServices} from './useCentralServices'
import {GetTypeModuleDto} from '../../../central/model'
import {selectMapperByKeys} from '../../mappers/util'
import {MasterFiltersDto} from '../../../hoteleria/features/modules/models'

export const useParameters = () => {
  const [loadingTypeModules, setLoadingTypeModules] = React.useState(false)
  const [typeModules, setTypeModules] = React.useState<{value: string; label: string}[]>([])
  const [loadingStatusModules, setLoadingStatusModules] = React.useState(false)
  const [statusModules, setStatusModules] = React.useState<{value: string; label: string}[]>([])
  const [loadingGenres, setLoadingGenres] = React.useState(false)
  const [genres, setGenres] = React.useState<{value: string; label: string}[]>([])
  const [loadingTypeBathrooms, setLoadingTypeBathrooms] = React.useState(false)
  const [typeBathrooms, setTypeBathrooms] = React.useState<{value: string; label: string}[]>([])
  const [loadingTypeBuildings, setLoadingTypeBuildings] = React.useState(false)
  const [typeBuildings, setTypeBuildings] = React.useState<{value: string; label: string}[]>([])
  const [loadingTypePreAsignations, setLoadingTypePreAsignations] = React.useState(false)
  const [typePreAsignations, setTypePreAsignations] = React.useState<
    {value: string; label: string}[]
  >([])
  const [loadingSuppliersCellphones, setLoadingSuppliersCellphones] = React.useState(false)
  const [suppliersCellphones, setSuppliersCellphones] = React.useState<
    {value: string; label: string}[]
  >([])
  const [loadingStatusCellphones, setLoadingStatusCellphones] = React.useState(false)
  const [statusCellphones, setStatusCellphones] = React.useState<{value: string; label: string}[]>(
    [],
  )
  const [loadingCleaningActivities, setLoadingCleaningActivities] = React.useState(false)
  const [cleaningActivities, setCleaningActivities] = React.useState<
    {value: string; label: string}[]
  >([])
  const [loadingTypeActions, setLoadingTypeActions] = React.useState(false)
  const [typeActions, setTypeActions] = React.useState<{value: string; label: string}[]>([])
  const [loadingCleaningActivitiesStatus, setLoadingCleaningActivitiesStatus] =
    React.useState(false)
  const [cleaningActivitiesStatus, setCleaningActivitiesStatus] = React.useState<
    {value: string; label: string}[]
  >([])
  const [statusScanDet, setStatusScanDet] = React.useState<{value: string; label: string}[]>([])
  const [loadingStatusScanDet, setLoadingStatusScanDet] = React.useState(false)
  const [typeReasons, setTypeReasons] = React.useState<{value: string; label: string}[]>([])
  const [loadingTypeReasons, setLoadingTypeReasons] = React.useState(false)

  const {getParams} = useCentralServices()

  const getTypeModules = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoadingTypeModules(true)
      const typeModules = await getParams(dto, filters)
      const mappedTypeModules = selectMapperByKeys(
        typeModules,
        options.idKey as any,
        options.labelKey as any,
      )
      setTypeModules(mappedTypeModules)
    } catch (error) {
      console.error('Error fetching clients:', error)
    } finally {
      setLoadingTypeModules(false)
    }
  }

  const getStatusModules = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoadingStatusModules(true)
      const statusModules = await getParams(dto, filters)
      const mappedStatusModules = selectMapperByKeys(
        statusModules,
        options.idKey as any,
        options.labelKey as any,
      )
      setStatusModules(mappedStatusModules)
    } catch (error) {
      console.error('Error fetching status modules:', error)
    } finally {
      setLoadingStatusModules(false)
    }
  }

  const getGenres = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoadingGenres(true)
      const genres = await getParams(dto, filters)
      const mappedGenres = selectMapperByKeys(genres, options.idKey as any, options.labelKey as any)
      setGenres(mappedGenres)
    } catch (error) {
      console.error('Error fetching genres:', error)
    } finally {
      setLoadingGenres(false)
    }
  }

  const getTypeBathrooms = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoadingTypeBathrooms(true)
      const typeBathrooms = await getParams(dto, filters)
      const mappedTypeBathrooms = selectMapperByKeys(
        typeBathrooms,
        options.idKey as any,
        options.labelKey as any,
      )
      setTypeBathrooms(mappedTypeBathrooms)
    } catch (error) {
      console.error('Error fetching type bathrooms:', error)
    } finally {
      setLoadingTypeBathrooms(false)
    }
  }

  const getTypeBuildings = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoadingTypeBuildings(true)
      const typeBuildings = await getParams(dto, filters)
      const mappedTypeBuildings = selectMapperByKeys(
        typeBuildings,
        options.idKey as any,
        options.labelKey as any,
      )
      setTypeBuildings(mappedTypeBuildings)
    } catch (error) {
      console.error('Error fetching type buildings:', error)
    } finally {
      setLoadingTypeBuildings(false)
    }
  }

  const getTypePreAsignations = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoadingTypePreAsignations(true)
      const typePreAsignations = await getParams(dto, filters)
      const mappedPreAsignations = selectMapperByKeys(
        typePreAsignations,
        options.idKey as any,
        options.labelKey as any,
      )
      setTypePreAsignations(mappedPreAsignations)
    } catch (error) {
      console.error('Error fetching pre asignations:', error)
    } finally {
      setLoadingTypePreAsignations(false)
    }
  }

  const getSuppliersCellphones = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoadingSuppliersCellphones(true)
      const suppliers = await getParams(dto, filters)
      const mappedSuppliers = selectMapperByKeys(
        suppliers,
        options.idKey as any,
        options.labelKey as any,
      )
      setSuppliersCellphones(mappedSuppliers)
    } catch (error) {
      console.error('Error fetching suppliers for cellphones:', error)
    } finally {
      setLoadingSuppliersCellphones(false)
    }
  }

  const getStatusCellphones = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoadingStatusCellphones(true)
      const status = await getParams(dto, filters)
      const mappedStatus = selectMapperByKeys(status, options.idKey as any, options.labelKey as any)
      setStatusCellphones(mappedStatus)
    } catch (error) {
      console.error('Error fetching status for cellphones:', error)
    } finally {
      setLoadingStatusCellphones(false)
    }
  }

  const getCleaningActivities = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
    optionsAll: {all: boolean; value: any; label: string} = {
      all: false,
      value: null,
      label: 'TODOS',
    },
  ) => {
    try {
      setLoadingCleaningActivities(true)
      const activities = await getParams(dto, filters)
      let mappedActivities = selectMapperByKeys(
        activities,
        options.idKey as any,
        options.labelKey as any,
      )
      let filteredData = mappedActivities.filter((item) => item.value !== '4EsB2NAAsDA=')
      if (optionsAll.all && filteredData.length > 0) {
        filteredData = [{value: optionsAll.value, label: optionsAll.label}, ...filteredData]
        setCleaningActivities(filteredData)
        return filteredData
      } else {
        setCleaningActivities(filteredData)
      }
      // mappedActivities = [{value: 'TODOS', label: 'TODOS'}, ...mappedActivities]
      // setCleaningActivities(mappedActivities)
    } catch (error) {
      console.error('Error fetching cleaning activities:', error)
    } finally {
      setLoadingCleaningActivities(false)
    }
  }

  const getTypeActions = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
    optionsAll: {all: boolean; value: any; label: string} = {
      all: false,
      value: null,
      label: 'TODOS',
    },
  ) => {
    try {
      setLoadingTypeActions(true)
      const actions = await getParams(dto, filters)
      let mappedActions = selectMapperByKeys(actions, options.idKey as any, options.labelKey as any)
      let filteredData = mappedActions.filter((item) => item.value !== '4EsB2NAAsDA=')
      if (optionsAll.all && filteredData.length > 0) {
        filteredData = [{value: optionsAll.value, label: optionsAll.label}, ...filteredData]
        setTypeActions(filteredData)
        return filteredData
      } else {
        setTypeActions(filteredData)
      }
    } catch (error) {
      console.error('Error fetching type actions:', error)
    } finally {
      setLoadingTypeActions(false)
    }
  }

  const getCleaningActivitiesStatus = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoadingCleaningActivitiesStatus(true)
      const status = await getParams(dto, filters)
      const mappedStatus = selectMapperByKeys(status, options.idKey as any, options.labelKey as any)
      setCleaningActivitiesStatus(mappedStatus)
    } catch (error) {
      console.error('Error fetching cleaning activities status:', error)
    } finally {
      setLoadingCleaningActivitiesStatus(false)
    }
  }

  const getStatusScanDet = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoadingStatusScanDet(true)
      const statusScanDet = await getParams(dto, filters)
      const mappedStatusScanDet = selectMapperByKeys(
        statusScanDet,
        options.idKey as any,
        options.labelKey as any,
      )
      setStatusScanDet(mappedStatusScanDet)
    } catch (error) {
      console.error('Error fetching status scan det:', error)
    } finally {
      setLoadingStatusScanDet(false)
    }
  }

  const getTypeReasons = async (
    dto: GetTypeModuleDto,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoadingTypeReasons(true)
      const typeReasons = await getParams(dto, filters)
      const mappedTypeReasons = selectMapperByKeys(
        typeReasons,
        options.idKey as any,
        options.labelKey as any,
      )
      setTypeReasons(mappedTypeReasons)
    } catch (error) {
      console.error('Error fetching type reasons:', error)
    } finally {
      setLoadingTypeReasons(false)
    }
  }

  return {
    loadingTypeModules,
    typeModules,
    getTypeModules,
    loadingStatusModules,
    statusModules,
    getStatusModules,
    loadingGenres,
    genres,
    getGenres,
    loadingTypeBathrooms,
    typeBathrooms,
    getTypeBathrooms,
    loadingTypeBuildings,
    typeBuildings,
    getTypeBuildings,
    loadingTypePreAsignations,
    typePreAsignations,
    getTypePreAsignations,
    loadingSuppliersCellphones,
    suppliersCellphones,
    getSuppliersCellphones,
    loadingStatusCellphones,
    statusCellphones,
    getStatusCellphones,
    loadingCleaningActivities,
    cleaningActivities,
    getCleaningActivities,
    loadingTypeActions,
    typeActions,
    getTypeActions,
    loadingCleaningActivitiesStatus,
    cleaningActivitiesStatus,
    getCleaningActivitiesStatus,
    loadingStatusScanDet,
    statusScanDet,
    getStatusScanDet,
    loadingTypeReasons,
    typeReasons,
    getTypeReasons,
  }
}
